import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { BlockWidths } from '../../components/pageLayouts/BlockTypes.utils';
import { createBlockStyle } from '../blockMutualStyle';
import { Kasda } from '../../../Kasda/Kasda';

interface TwitterDataProps {
  dataId?: string;
  mediaId?: string; // This is the tweet ID
  defaultBlocksWidths: BlockWidths;
}

type TwitterProps = TwitterDataProps & MandatoryAdditionalStyle;

const getBlockStyle = (defaultBlocksWidths: BlockWidths) => {
  return StyleSheet.create({
    style: {
      ...createBlockStyle(defaultBlocksWidths),
      display: 'flex',
      justifyContent: 'center',
    },
  }).style;
};

const TwitterScript = `window.twttr = (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0],
    t = window.twttr || {};
  if (d.getElementById(id)) return t;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://platform.twitter.com/widgets.js";
  fjs.parentNode.insertBefore(js, fjs);
  t._e = [];
  t.ready = function(f) {
    t._e.push(f);
  };
  return t;
}(document, "script", "twitter-wjs"));`;

export const TwitterComponent: React.FunctionComponent<TwitterProps> = props => {
  const { dataId, mediaId, additionalStyle, defaultBlocksWidths } = props;
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [minHeight, setMinHeight] = React.useState(550);

  const twitterStyle = getBlockStyle(defaultBlocksWidths);

  React.useEffect(() => {
    if (typeof window === 'undefined' || !containerRef.current) return;

    // Poll for twttr.widgets and containerRef
    const tryRender = () => {
      // @ts-ignore
      if (window.twttr && window.twttr.widgets && containerRef.current) {
        // @ts-ignore
        window.twttr.widgets
          .createTweet(mediaId, containerRef.current)
          .then((el: HTMLElement | undefined) => {
            if (el) {
              setMinHeight(el.offsetHeight);
            }
          })
          .catch((err: unknown) => {
            console.error('Twitter embed error:', err);
          });
      } else {
        setTimeout(tryRender, 200);
      }
    };
    tryRender();
  }, [mediaId]);

  return (
    <ErrorBoundary>
      <Kasda.Script>
        <script>{TwitterScript}</script>
      </Kasda.Script>
      <figure
        data-mm-id={dataId}
        className={css(twitterStyle, additionalStyle?.style)}
        style={{ minHeight }}
      >
        <div ref={containerRef} style={{ width: '100%' }} />
      </figure>
    </ErrorBoundary>
  );
};

export const Twitter = (props: TwitterProps) => (
  <ErrorBoundary>
    <TwitterComponent {...props} />
  </ErrorBoundary>
);
